<template>
  <div>
    <!--   所属分类-->
    <div>
      <div class="filter-con" style="padding-top: 0px;padding-bottom: 0px">
        <div class="sceneTitle">所属分类</div>
        <div class="tag-con">
          <el-popover
            :key="tag.id"
            v-for="(tag, index) in tagList"
            placement="bottom"
            trigger="click"
            :ref="'popover-' + tag.id"
            @show="onPopoverShow(tag.id)"
            :disabled = 'tag.showCarse'
          >
            <div>
              <el-cascader-panel
                ref="cascaderList"
                v-model="tag.select"
                @change="onCascaderChange(index)"
                :options="tag.children ? tag.children:[tag]"
                :props="tagProps"
              ></el-cascader-panel>
            </div>
            <span slot="reference" :class="['tag', tag.select ? 'active' : '']">
                {{ (tag.select || "").toString() || tag.name }}
                <i class="el-icon-arrow-down"></i>
              </span>
          </el-popover>
        </div>
      </div>
      <div class="filter-con">
        <div class="sceneTitle">证书类型</div>
        <div class="tag-con">
          <div
            class="tag"
            :class="type === item.value ? 'sceneBut':''"
            @click="getAll(item.value)"
            v-for="item in typeValue"
            :key="item.value">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="filter-con" v-if="selectTags.length > 0" style="padding-top: 10px">
      <div class="title">已选：</div>
      <div class="tag-con">
      <span class="sel-tag" v-for="tag in selectTags" :key="tag">
        {{ tag }}
        <span @click="onSelectTagRemove(tag)" class="del"></span>
      </span>
      </div>
    </div>
    <div style="padding: 8px 7px;background-color: #fff">
<!--      图片-->
      <div class="list" v-if="type === 0">
        <div class="item" :key="item.id" v-for="item in dataList">
          <div>
            <el-tooltip class="itemlist" effect="dark" placement="bottom" popper-class="tool-tip" v-if="item.serialNumber || item.tags1">
              <div slot="content" style="max-width: 260px">
                <div>编号：{{ item.serialNumber }}</div>
                <div>
                  标签：
                  <span v-for="(tag,index) of item.tags1" :key="tag.id">{{ tag.tagsName }}
                    <span v-if="index != item.tags1.length - 1">,</span>
                  </span>
                </div>
              </div>
              <el-image
                :preview-src-list="previewSrcList"
                :src="item.url"
                fit="fit"
                class="img"
              />
            </el-tooltip>
            <el-image
              :preview-src-list="previewSrcList"
              :src="item.url"
              fit="fit"
              class="img"
              v-else
            />
          </div>
          <div class="info">
            <div class="title">{{ item.image.name }}</div>
            <div class="date">创建于 {{ item.createTime }}</div>
          </div>
        </div>
      </div>
      <div v-else style="padding: 5px 24px;background-color: #fff">
        <el-table
        :data="dataList"
        :header-cell-style="{background:'#EBE9E9', color:'#000000', fontsize:'16px', textAlign:'center'}"
        :cell-style="{ color: 'rgba(0,0,0,0.85)', fontsize:'14px', textAlign:'center'}">
          <el-table-column label="编号" prop="serialNumber"></el-table-column>
          <el-table-column label="名称" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.image.name }}
            </template>
          </el-table-column>
          <el-table-column label="标签" min-width="180">
            <template slot-scope="scope">
              <span v-for="(tag,index) of scope.row.tags1" :key="tag.id">{{ tag.tagsName }}
                  <span v-if="index != scope.row.tags1.length - 1">,</span>
                </span>
            </template>
          </el-table-column>
          <el-table-column label="所属模块" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.image.moduleName">
                  {{ scope.row.image.moduleName }}
                </span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" min-width="120"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span style="cursor: pointer;color:#E60027 "  @click="dialogPdf = true, url = scope.row.url, pagePdf = 1">预览</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="dataList.length === 0 && type === 0" class="decs">暂无数据</div>
      <div>
        <el-pagination
          @size-change="sizeChangeHandleHis"
          @current-change="currentChangeHandleHis"
          :current-page="pageNum"
          :page-sizes="[12, 24, 36, 50, 100]"
          :page-size="pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;padding-bottom: 20px;margin: 25px 50px">
        </el-pagination>
      </div>
      <!--    pdf-->
      <el-dialog
        :visible.sync="dialogPdf"
        width="40%"
        :before-close="closePdf"
      >
        <pdfConten :url="url" :current-page="pagePdf" @changeadd='changeadd' @changecont='changecont'></pdfConten>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getImageList, ImageData } from "@/api/queriesList";
import { getGalleryList, getGalleryTagList } from "../../api/gallery";
import moment from "moment";
import pdfConten from '@/components/queries/pdfConten'

export default {
  name: "certificate",
  props: {
    fileName: {
      type: String,
      default: () => null
    },
    tagName: {
      type: String,
      default: () => null
    }
  },
  components: {
    pdfConten
  },
  data() {
    return {
      pagePdf: 1,
      url: '',
      dialogPdf: false,
      pageNum: 1,
      pageSize: 12,
      sceneNum: 0,
      total:0,
      sceneList: [],
      tagList: [],
      popoverId: null,
      tagProps: {
        value: "name",
        label: "name",
        children: "children",
        checkStrictly: true
      },
      dataList: [],
      selectList:[],
      previewSrcList: [],
      typeValue: [
        {
          value: 0,
          name: '图片'
        },
        {
          value: 1,
          name: 'PDF'
        }
      ],
      type: 0
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  computed: {
    selectTags() {
      let result = [];

      let getTags = list => {
        list?.forEach(item => {
          if (item.select) {
            result.push(item.select.toString());
          }
          getTags(item.children);
        });
      };

      getTags(this.tagList);
      return result;
    },
    selectTagIds() {
      let result = [];
      let tagName = null
      this.tagList.forEach(item => {
        if (item.select) {
          tagName = [item.select[item.select.length - 1]];
        }
      })
      let getTagIds = list => {
        list?.forEach(item => {
          let selectOne = item.children?.find(aa => aa.name == tagName);
          if(!selectOne) {
            if(item.name === [tagName].toString()) {
              result.push(item.id)
            }else {
              item.children?.forEach(obj => {
                let selectTag = obj.children?.find(oo => oo.name == tagName);
                if (selectTag) {
                  result.push(selectTag.id);
                }else {
                  getTagIds(obj.children)
                }
              });
            }
          }else {
            result.push(selectOne.id);
          }
        getTagIds(item.children);
        });
      };
      getTagIds(this.tagList);
      return result;
    },
  },
  mounted() {
    this.getAllTags();
  },
  methods: {
    changeadd(params) {
      this.pagePdf += params
    },
    changecont(params) {
      this.pagePdf -= params
    },
    closePdf() {
      this.dialogPdf = false
      this.url = ''
      this.pagePdf = 1
    },
    // 类型
    getAll(type) {
      this.type = type
      this.pageNum = 1
      this.getGalleryList()
    },
    getTreeData(data){
      for(let i=0;i<data.length;i++){
        if(data[i].children.length<1){
          // child若为空数组，则将child设为undefined
          data[i].children = undefined;
        }else {
          // child若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    getAllTags() {
      this.tagList = [];
      getImageList( "1" )
        .then(res => {
          if (res.code == 200) {
            let initModel = list => {
              (list.children || []).forEach(item => {
                item.select = null;
                initModel(item.children);
              });
            };
            let tagList = this.getTreeData(res.data[0].children);
            initModel(tagList);
            tagList.forEach(item => {
              item.showCarse = false
            })
            this.tagList = tagList;
          }
        })
        .finally(_ => {
          this.pageNum = 1
          this.getGalleryList();
        });
    },
    onPopoverShow(id) {
      this.popoverId = id;
    },
    onSelectTagRemove(tag) {
      console.log(tag)
      let firstTage=tag.split(',')[0]
      this.tagList?.forEach(item => {
        if(item.name === firstTage) {
          item.select = null;
        }else {
          let hasTag = item.children?.find(obj => obj.name == firstTage);
          console.log(item.children)
          if (hasTag) {
            item.select = null;
          }
        }
      });
      if(!this.selectTags.length) {
        this.tagList.forEach((item, index) => {
          item.showCarse = false
        })
      }
      this.getList();
    },
    onCascaderChange(e) {
      this.pageNum = 1
      this.tagList.forEach((item, index) => {
        if(index !== e){
          item.showCarse = true
          console.log(document.getElementsByClassName('tag'))
        }
      })
      this.$refs["popover-" + this.popoverId][0].doClose();
      this.getList();
      const panelRefs = this.$refs.cascaderList // 节点刷新，页面回显
      // if(!panelRefs.getCheckedNodes()[0].children || !panelRefs.getCheckedNodes()[0].children.length) {
      //   panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      // }
    },
    getGalleryList() {
      let data = {
        // moduleIds: [2],
        tagSearchValue: this.tagName,
        moduleIds: this.selectTagIds,
        name: this.fileName,
        startTime: "",
        rootModuleId: '1',
        endTime: "",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: 1,
        type: this.type
      };
      ImageData(data).then(res => {
        if (res.code == 200) {
          let records = res.data.records;
          records.forEach(item => {
            item.createTime = item.createTime.replace("T", " ").slice(0, 16);
            this.previewSrcList.push(item.url)
          });
          this.dataList = records;
          this.total = res.data.total
        }
      });
    },
    getList() {
      this.pageNum = 1;
      this.getGalleryList();
    },
    // 每页数
    sizeChangeHandleHis (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getGalleryList()
    },
    // 当前页
    currentChangeHandleHis (val) {
      this.pageNum = val
      this.getGalleryList()
    },
  },
}
</script>

<style scoped lang="less">
.sceneBut{
  background: #FFCCC7;
  color: #E60027 ;
  border-color: #FFCCC7 !important;
}
.decs{
  text-align: center;
  color: #7d7d7d;
}
::v-deep .el-radio__inner {
  top: -18px;
  left: -19px;
  border-radius: 0;
  border: 0;
  width: 170px;
  height: 34px;
  background-color: transparent;
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: transparent;
}
::v-deep .el-image {
  width: 3.4rem;
  height: 1.9rem;
  border-radius: 0.12rem;
}
::v-deep .el-image__inner{
  overflow: hidden;
  object-fit: cover;
}
.list {
  display: flex;
  flex-wrap: wrap;
  & > .item {
    flex: 0 0 3.4rem;
    margin: 0.16rem;
    margin-bottom: 0;
    & > .img {
      height: 1.9rem;
      border-radius: 0.12rem;
      background-position: center center;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    & > .info {
      padding-bottom: 0.16rem;
      & > .title {
        font-size: 0.14rem;
        color: rgba(0, 0, 0, 0.85);
        padding-top: 0.12rem;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        // height: .64rem;
      }
      & > .tags {
        & > span {
          font-size: 0.12rem;
          color: rgba(0, 0, 0, 0.85);
          line-height: 0.2rem;
          font-weight: 400;
          display: inline-block;
        }
      }
      & > .date {
        color: rgba(0, 0, 0, 0.45);
        font-size: 0.12rem;
        padding-top: 0.04rem;
      }
    }
  }
}
.sceneBut{
  background: #FFCCC7;
  color: #E60027 ;
  border-color: #FFCCC7 !important;
}
.filter-con {
  padding: 0.1rem 0.3rem;
  display: flex;
  align-items: center;
  & > .title {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-weight: bold;
  }
  & > .sceneTitle{
    padding-top: 11px;
    width: 95px;
    line-height: 32px;
    font-size: 14px;
    font-family: Inter-Medium, Inter;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
  & > .tag-con {
    flex: 1;
    & .tag {
      display: inline-block;
      border-radius: 18px;
      border: 1px solid #c0c4cc;
      margin: 0 0.04rem;
      line-height: 34px;
      padding: 0 0.16rem;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      margin-top: 8px;
      &.active {
        background-color: #ffccc7;
        color: #e60027;
        border-color: #ffccc7;
      }
    }
    & .sel-tag {
      padding: 0 0.12rem;
      background-color: #f5f5f5;
      color: rgba(0, 0, 0, 0.6);
      line-height: 0.28rem;
      height: 0.28rem;
      display: inline-block;
      font-size: 0.14rem;
      margin: 0 0.06rem;
      position: relative;
      & > .del {
        position: absolute;
        width: 0.16rem;
        height: 0.16rem;
        background: url("~@/assets/imgs/icon_gray_close@2x.png") no-repeat center center / 100% auto;
        top: -0.08rem;
        right: -0.04rem;
        cursor: pointer;
      }
    }
  }
}
.scene{
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-left: 24px;
  .sceneTitle{
    margin-top: 5px;
    width: 100px;
    line-height: 32px;
    font-size: 14px;
    font-family: Inter-Medium, Inter;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
}
.sceneConten{
  display: flex;
  flex-wrap: wrap;
  div{
    line-height: 34px;
    width: 95px;
    border-radius: 18px;
    opacity: 1;
    border: 1px solid #c0c4cc;
    text-align: center;
    margin-right: 8px;
    cursor: pointer;
  }
}
</style>
